/* ADD GROUPS */
export const ADD_QUIZZ_ANSWER = "ADD_QUIZZ_ANSWER"
export const ADD_QUIZZ_ANSWER_SUCCESS = "ADD_QUIZZ_ANSWER_SUCCESS"
export const ADD_QUIZZ_ANSWER_CLEAN = "ADD_QUIZZ_ANSWER_CLEAN"
export const ADD_QUIZZ_ANSWER_ERROR = "ADD_QUIZZ_ANSWER_ERROR"
